import type { AccessLogEntry } from './types';

/** `k=v; k=v`, the way the CSV writes it, so the screen and the file read the same. */
export function detailText(detail: AccessLogEntry['detail']): string {
  if (!detail) return '';
  return Object.entries(detail)
    .map(([key, value]) => `${key}=${typeof value === 'string' ? value : JSON.stringify(value)}`)
    .join('; ');
}

/** A `Date` as the local day an `<input type="date">` shows. */
export function localDay(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${date.getFullYear()}-${month}-${day}`;
}

/** A `<input type="date">` value as the first instant of that local day, ISO. */
export function startOfDay(day: string): string | undefined {
  if (!day) return undefined;
  return new Date(`${day}T00:00:00`).toISOString();
}

/** The first instant of the *next* day: `until` is exclusive in the API, and «hasta el
 * 12» means the whole 12th. */
export function endOfDay(day: string): string | undefined {
  if (!day) return undefined;
  const next = new Date(`${day}T00:00:00`);
  next.setDate(next.getDate() + 1);
  return next.toISOString();
}

/** The inverse of `endOfDay`, for the field to show the day the person picked. */
export function untilAsDay(until: string | undefined): string {
  if (!until) return '';
  const previous = new Date(until);
  previous.setDate(previous.getDate() - 1);
  const month = String(previous.getMonth() + 1).padStart(2, '0');
  const day = String(previous.getDate()).padStart(2, '0');
  return `${previous.getFullYear()}-${month}-${day}`;
}
